import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useHistory } from "react-router-dom";
import "./Header.css";
import { Link } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons }) => {
  // console.log(hasHiddenAuthButtons);
  //let isLoggedIn = localStorage.getItem("token");
  let history = useHistory();

  if (
    hasHiddenAuthButtons === true &&
    !localStorage.hasOwnProperty("username")
  ) {
    return (
      <Box className="header">
        <Link to="/">
          <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
          </Box>
        </Link>

        {children}

        <Box>
          <Link to="/login">
            <Button className="explore-button" variant="text">
              Login
            </Button>
          </Link>
          <Link to="/register">
            <Button color="success" variant="contained">
              Register
            </Button>
          </Link>
        </Box>
      </Box>
    );
  } else if (hasHiddenAuthButtons === false) {
    return (
      <Box className="header">
        <Link to="/">
          <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
          </Box>
        </Link>

        <Link to="/">
          <Button
            className="explore-button"
            startIcon={<ArrowBackIcon />}
            variant="text"
          >
            Back to explore
          </Button>
        </Link>
      </Box>
    );
  } else if (localStorage.hasOwnProperty("username")) {
    return (
      <Box className="header">
        <Link to="/">
          <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
          </Box>
        </Link>
        {children}
        <Box sx={{ display: "flex" }}>
          <Box sx={{ display: "flex" }}>
            <Avatar
              src="avatar.png"
              alt={localStorage.getItem(`username`)}
              style={{ marginRight: "8px", width: "50px", height: "50px",marginTop:"auto",marginBottom:"auto" }}
            />

            <h4 variant="text" sx={{marginTop:"auto",marginBottom:"auto"}} >
              {" "}
              {localStorage.getItem(`username`)}
            </h4>
          </Box>
          <Button
            className="explore-button"
            variant="text"
            onClick={() => {
              localStorage.clear();
              history.push(`/`);
              window.location.reload();
            }}
          >
            LOGOUT
          </Button>
        </Box>
      </Box>
    );
  } else {
    return <></>;
  }
};

export default Header;
